/**
 * Localized relative-time formatter ("5 minutes ago", "in 2 hours", etc.).
 * Returns an empty string for undefined input so callers can render it inline
 * without a null guard.
 */
export function formatRelativeTime(value: Date | undefined): string {
  if (!value) return ""
  const diffMs = value.getTime() - Date.now()
  const minutes = Math.round(diffMs / (60 * 1000))
  const rtf = new Intl.RelativeTimeFormat(undefined, {numeric: "auto"})
  if (Math.abs(minutes) < 60) return rtf.format(minutes, "minute")
  const hours = Math.round(minutes / 60)
  if (Math.abs(hours) < 24) return rtf.format(hours, "hour")
  const days = Math.round(hours / 24)
  return rtf.format(days, "day")
}

/**
 * Compact relative-time formatter for feed rows ("4h", "1d", etc.).
 */
export function formatCompactRelativeTime(value: Date | string | undefined): string {
  if (!value) return ""
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ""
  return formatRelativeTime(date)
    .replace(" ago", "")
    .replace(" hours", "h")
    .replace(" hour", "h")
    .replace(" minutes", "m")
    .replace(" minute", "m")
    .replace(" days", "d")
    .replace(" day", "d")
}
